import axiosServices from "../utils/axios";

export const addpdacalculatorReport= async (params: { notification_intro: String; port_callings_id: string; checked:boolean, jobId:string, email_list:string}) => {
    const {port_callings_id, jobId, email_list} =params;
    const data = {
        email_list
    }
  const response = await axiosServices.post(`/reports/pdacalculator?port_callings_id=${port_callings_id}&jobId=${jobId}`, data);
  return response.data;
};

export const getpdacalculatorReport = async (params: { notification_intro: String; port_callings_id: string; checked:boolean, jobId:string}) => {
  const {port_callings_id, jobId , checked} = params;
  const url=`/reports/pdacalculator?jobId=${jobId}&checked=${checked}&port_callings_id=${port_callings_id}`;
  const response = await axiosServices.get(`${url}`);
  return response.data;
};